import React, { Component } from 'react'

export class PagesHeader extends Component {
    render() {
        return (
            <header className={` ${this.props.className} h-[40vh] w-full max-[700px]:h-[40vh]`}>
                <div className='flex flex-col items-center p-[52px_0px] max-[1000px]:p-[20px_0px] '>
                    <h2 className='font-[800] text-[48px] text-[#fff] text-center max-[1000px]:text-[38px] max-[500px]:text-[32px] '>{this.props.title}</h2>
                    <div className='flex justify-center w-[70%]'>
                        <p className='font-[600] text-[20px] text-[#fff] mt-[10px] max-[1000px]:text-[18px] max-[580px]:text-[16px] max-[450px]:text-[14px] max-[350px]:text-[13px]  text-center'>
                            {this.props.text}
                        </p>
                    </div>

                </div>
            </header>
        )
    }
}

export default PagesHeader